module.exports = __webpack_public_path__ + "img/Frente-30-01 on.58a5a55a.png";